import { mountDeclaredReactIslands } from "./islands/mount-islands";

function bootstrap() {
  mountDeclaredReactIslands();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
} else {
  bootstrap();
}
